export default "__VITE_ASSET__CoH4Yqgh__"